// =====================================================
// WeLearn Pro Player - Quiz module
// =====================================================

import Debug from './util/debugHelper';
import Progress from "./progress";

const QuizFlags = Object.freeze({
    finished: Symbol('finished'),
    unfinished: Symbol('unfinished')
});

export default class Quiz {
    constructor(player) {
        this.player = player;
        this.progress = new Progress(this.player);
        this.debug = new Debug(this.player.options.debug);
    }

    /**
     * Invoke quiz by quiz ID.
     * @param quizId - Quiz ID
     */
    invokeQuiz(quizId, quizCourseSectionModuleId) {
        let self = this;

        self.player.progressData = this.progress.buildProgressData();
        self.progress.updateVideoData(self.player.progressData);

        $.ajax({
            url: '/Learning/QuizRedirect/',
            data: {
                courseId: self.player.progressData.courseId,
                csm: quizCourseSectionModuleId, // Note: csm of QUIZ NOT VIDEO!
                quizId: quizId,
                seekable: self.player.options.seekable,
                vid: self.player.videoComponent.videoId,
                cb: self.player.progressData.courseBatchId,
                cs: self.player.progressData.courseSectionId,
                vidcsm: self.player.progressData.courseSectionModuleId
            },
            type: 'get',
            success: function (result) {
                if (result !== "pass") {
                    self.player.plyrPlayer.pause();

                    $("#video-quiz-redirect-container").html(result);
                    $('#video-quiz-redirect').modal({
                        backdrop: 'static',
                        keyboard: false
                    });
                    $('#video-quiz-redirect').modal('show');
                }

                return true;
            },
            error: function (result) {
                return false;
            }
        });

        return false;
    }

    /**
     * Unload quiz and unhide course video
     */
    unloadQuiz() {
        let self = this;

        if ($('#quiz-learning').length) {
            $('#quiz-learning').remove();
            $('#course-lrn').show();
            self._enableNavigations();
        }
    }

    _disableNavigations() {
        $('#ddlchat').css({ 'opacity': '0.5', 'pointer-events': 'none' });
        $('#ddlcourse').css({ 'opacity': '0.5', 'pointer-events': 'none' });
        $('#ddldownload').css({ 'opacity': '0.5', 'pointer-events': 'none' });
        $('#ddlmemo').css({ 'opacity': '0.5', 'pointer-events': 'none' });
    }

    _enableNavigations() {
        $('#ddlchat').css({ 'opacity': '1', 'pointer-events': 'auto' });
        $('#ddlcourse').css({ 'opacity': '1', 'pointer-events': 'auto' });
        $('#ddldownload').css({ 'opacity': '1', 'pointer-events': 'auto' });
        $('#ddlmemo').css({ 'opacity': '1', 'pointer-events': 'auto' });
    }

    _flag(flag, time) {
        switch (flag) {
            case (QuizFlags.finished):
                $(`span.tick[data-timestamp=${time}]`).addClass('finished-test');
                return true;

            case (QuizFlags.unfinished):
                $(`span.tick[data-timestamp=${time}]`).addClass('unfinished-test');
                return true;

            default:
                return false;
        }
    }
}